@if (colored) {
    <svg
        [attr.height]="height"
        [attr.width]="width"
        fill="none"
        style="overflow: visible"
        viewBox="2.7 5 30.5 26"
        xmlns="http://www.w3.org/2000/svg">
        <g>
            <path clip-rule="evenodd"
                d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33ZM17.6065 20.2335C16.6223 20.6859 15.934 21.6825 15.934 22.8331C15.934 24.4054 17.2188 25.6917 18.7891 25.6917H20.7402C19.6014 26.7874 18.5963 27.7516 18.5963 27.7516C18.2697 28.0828 17.7439 28.0828 17.4175 27.7516C17.4175 27.7516 12.335 22.8767 12.0799 22.5935L12.0754 22.5891H12.0759C10.7505 21.1155 9.94061 19.1471 9.94061 16.9845C9.94061 12.417 13.552 8.71429 18.0068 8.71429C20.51 8.71429 22.7468 9.88336 24.2263 11.7179L23.1209 12.6087H22.6251H21.8798H21.3839L17.9285 9.82401C17.6476 9.59766 17.23 9.79783 17.23 10.1589V12.6087H17.1455L17.145 12.6095C17.1406 12.6094 17.1363 12.6093 17.1319 12.6091C17.126 12.6089 17.12 12.6087 17.1139 12.6087C15.8846 12.6087 14.8881 13.6066 14.8881 14.8375C14.8881 16.0241 15.8145 16.9938 16.9826 17.0619L17.6065 20.2335Z"
                fill="var(--primary-blue-color)"
                fill-rule="evenodd"/>
        </g>
    </svg>
} @else {
    <svg
        [attr.height]="height"
        [attr.width]="width"
        fill="none"
        style="overflow: visible"
        viewBox="2.7 5 30.5 26"
        xmlns="http://www.w3.org/2000/svg">
        <g>
            <path clip-rule="evenodd"
                d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33ZM17.6065 20.2335C16.6223 20.6859 15.934 21.6825 15.934 22.8331C15.934 24.4054 17.2188 25.6917 18.7891 25.6917H20.7402C19.6014 26.7874 18.5963 27.7516 18.5963 27.7516C18.2697 28.0828 17.7439 28.0828 17.4175 27.7516C17.4175 27.7516 12.335 22.8767 12.0799 22.5935L12.0754 22.5891H12.0759C10.7505 21.1155 9.94061 19.1471 9.94061 16.9845C9.94061 12.417 13.552 8.71429 18.0068 8.71429C20.51 8.71429 22.7468 9.88336 24.2263 11.7179L23.1209 12.6087H22.6251H21.8798H21.3839L17.9285 9.82401C17.6476 9.59766 17.23 9.79783 17.23 10.1589V12.6087H17.1455L17.145 12.6095C17.1406 12.6094 17.1363 12.6093 17.1319 12.6091C17.126 12.6089 17.12 12.6087 17.1139 12.6087C15.8846 12.6087 14.8881 13.6066 14.8881 14.8375C14.8881 16.0241 15.8145 16.9938 16.9826 17.0619L17.6065 20.2335Z"
                fill="#424242"
                fill-rule="evenodd"/>
        </g>
    </svg>
}
